/** @mixin overflowAutoMixin */

/**
 * Adds vertical scrolling style to a components,
 * often used with `overflowPaddingMixin`.
 *
 * @example
 * import { overflowAutoMixin, overflowPaddingMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *      ${overflowAutoMixin}
 *      ${overflowPaddingMixin(
 *          spaceMixin('xs'),
 *          spaceMixin('md'),
 *          spaceMixin('xl'),
 *          spaceMixin('sm')
 *      )};
 * `;
 *
 * <Component>component vertical scrollable with overflow padding</Component>
 *
 * @method
 * @return {CSSObject}
 */
export var overflowAutoMixin = function overflowAutoMixin() {
  return "\n    overflow-y: auto;\n    // support smooth scrolling in iOS Safari\n    -webkit-overflow-scrolling: touch;\n";
};